import React from 'react';
import './Agenda.css';

const Agenda = () => {
    const events = [
        // { date: 'JUL 12', city: 'IBIZA', venue: 'USHUAIA' },
        // { date: 'JUL 24', city: 'MYKONOS', venue: 'SCORPIOS' },
        // { date: 'AUG 05', city: 'TULUM', venue: 'ZAMNA' },
        // { date: 'AUG 18', city: 'PARIS', venue: 'L\'ARC' },
        // { date: 'SEP 02', city: 'DUBAI', venue: 'SOHO GARDEN' },
    ];

    return (
        <section className="agenda-section">
            <h2>AGENDA</h2>
            <ul className="agenda-list">
                {events.map((event, index) => (
                    <li key={index} className="agenda-item">
                        <span className="event-date">{event.date}</span>
                        <span className="event-city">{event.city}</span>
                        <span className="event-venue">{event.venue}</span>
                    </li>
                ))}
            </ul>
        </section>
    );
};

export default Agenda;
